import { Component, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../carta/services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CartaMenuServices } from '../services';
import { QRServices } from '../../services/qrServices';
import { ShareXxssPage } from '../../components/share-xxss/share-xxss';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CartaCreateSelectTemplatePage } from '../../carta/carta-create/carta-create-select-template/carta-create-select-template';
import { CartaMenuViewPage } from '../carta-menu-view/carta-menu-view';
import { AnalyticsServices } from '../../services/analyticsServices';
import moment from 'moment';
import { MenuCreateSelectTemplatePage } from '../../menu/menu-create/menu-create-select-template/menu-create-select-template';
import { ComboCreateSelectTemplatePage } from '../../combo/combo-create/combo-create-select-template/combo-create-select-template';
import { MenuServices } from '../../menu/services';
import { ComboServices } from '../../combo/services';
import { AnayliticsMenuComboPage } from '../../components/anaylitics-menu-combo/anaylitics-menu-combo';
import { ComboViewSimulatorPage } from '../../combo/combo-view/combo-view-simulator/combo-view-simulator';
import { CartaViewSimulatorPage } from '../../carta/carta-view/carta-view-simulator/carta-view-simulator';

@Component({
  selector: 'page-cartas-menus-list',
  templateUrl: 'cartas-menus-list.html',
})
export class CartasMenusListPage {
  cartas: any = [];
  actual_day = moment().format('YYYY-MM-DD HH:mm:ss');
  actual_day_less_6 = moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss');
  url_share = this.globals.share_path + this.globals.domini_sites;
  total_views = 0;
  total_shares = 0;
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'ref', dir: 'asc' },
    { prop: 'type', dir: 'asc' },
    { prop: 'price', dir: 'asc' },
    { prop: 'digital_app', dir: 'asc' },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public cartaServices: CartaServices,
    public cartaMenuServices: CartaMenuServices,
    public translate: TranslateService,
    public qrServices: QRServices,
    public modalCtrl: ModalController,
    public analyticsServices: AnalyticsServices,
    private menuServices: MenuServices,
    private comboServices: ComboServices,) {
  }

  async ionViewWillEnter() {
    if (this.globals.restaurant.plg_cartamenu_starter == undefined || this.globals.restaurant.plg_cartamenu_starter == false) {
      //save octupus_cartamenu_list y plg_cartamenu_starter
      this.cartaMenuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_cartamenu_starter: true
      });
      this.globals.restaurant.plg_cartamenu_starter = true;
      //update hubspot contact
      this.globals.updateERPNextCustomer();
    }
    //Get cartas/menus/combos
    if (this.cartaMenuServices.cartas_menu_combo_array_tmp.length > 0) {
      setTimeout(() => {
        this.cartaMenuServices.getPagesCartasMenusCombos(true);
      }, 1500);
    } else {
      this.cartaMenuServices.getPagesCartasMenusCombos(false);
    }
    //Get analytics
    this.getViewsShares();
  }

  createCarta() {
    if (this.globals.checkLimitsByLicense('menus', 'max_menus') > -1) { //Si limit menus
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {//Si no limit menus
      this.navCtrl.push(CartaCreateSelectTemplatePage, {
        update_state: false,
        carta_uid: '',
        carta_name: '',
        new_carta: true
      });
    }
  }

  createMenu() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'limit') > -1) { //Si limit menus
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {//Si no limit menus
      this.navCtrl.push(MenuCreateSelectTemplatePage, {
        update: false,
        new_menu: true
      });
    }
  }

  createCombo() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'limit_combo') > -1) { //Si limit menus
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {//Si no limit menus
      this.navCtrl.push(ComboCreateSelectTemplatePage, {
        update_state: false,
        new_combo: true
      });
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      //Comprovamos que el elemento este activo por version
      if (event.row._active) {
        let fs_collection = '';
        //Comprovamos a que collection pertence el elemento
        if (event.row.type === 'carta') {
          fs_collection = 'cartas';
        } else {
          fs_collection = 'menus';
        }
        //Comprovamos la columna para hacer una accion u otra
        if (event.column.name === 'digital_app') {
          if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            //update element tpv_active
            if (event.row.digital_app == undefined) {
              event.row.digital_app = true;
            }
            this.updateElementFirestore(fs_collection, event.row.UID, { digital_app: !event.row.digital_app });
            event.row.digital_app = !event.row.digital_app;
          } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
          }
        } else if (event.column.name === 'pdf') {
          if (this.globals.checkLimitsByLicense('menus', 'print')) {
            //Vamos al share y que salga el modal de imprimir
            this.analyticsServices.trackingExp('imprimir', this.globals.tracking_exp['print_element'], event.row.UID);
            this.globals.GAtrackView('Cartas/Menús', 'Cartas/Menús - Print', this.globals.restaurant.email, 'List', 'Print Cartas/Menús', 'Cartas/Menús', '');
            window.open(this.globals.share_path + this.globals.domini_sites + '/' + event.row.type + '/' + event.row.UID + '?lang=' + this.globals.restaurant.lang + '&print=true', '_blank');
          } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
          }
        } else if (event.column.name === 'qr') {
          //Generamos el qr del elemento
          this.analyticsServices.trackingExp('crear qr', this.globals.tracking_exp['create_qr'], event.row.UID);
          this.qrServices.generateMenuCartaGR(event.row.UID, event.row.type);
        } else if (event.column.name === 'share') {
          this.globals.GAtrackView('Cartas/Menús', 'Cartas/Menús - Share', this.globals.restaurant.email, 'List', 'Share Cartas/Menús', 'Cartas/Menús', '');
          if (event.row.type === 'carta') {
            this.cartaServices.carta_tmp = event.row;
          } else if (event.row.type === 'menu' || event.row.type === 'combo') {
            this.menuServices.menu_tmp = event.row;
          }
          this.openShare(this.globals.share_path + this.globals.domini_sites + '/' + event.row.type + '/' + event.row.UID + '?lang=' + this.globals.restaurant.lang, event.row.type, event.row.UID);
        } else if (event.column.name === 'preview') {
          window.open(this.globals.share_path + this.globals.domini_sites + '/' + event.row.type + '/' + event.row.UID + '?lang=' + this.globals.restaurant.lang, '_blank');
        } if (event.column.name === 'analytics') {
          //abrimos analytics segun type
          if (event.row.type == 'menu') {
            this.menuServices.menu_tmp = event.row;
            this.navCtrl.push(AnayliticsMenuComboPage, {
              menu_uid: this.menuServices.menu_tmp.UID,
              menu_title: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp)
            });
          } else if (event.row.type == 'combo') {
            this.menuServices.menu_tmp = event.row;
            this.navCtrl.push(ComboViewSimulatorPage, {
              combo_title: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp)
            });
          } else {
            this.cartaServices.carta_tmp = event.row;
            this.navCtrl.push(CartaViewSimulatorPage, {
              carta_title: this.globals.returnLangCartaMenuCombo(this.cartaServices.carta_tmp)
            });
          }
        } else {
          //openView
          this.navCtrl.push(CartaMenuViewPage, {
            type: event.row.type,
            state: 'view',
            uid_element: event.row.UID
          });
        }
      } else {
        this.navCtrl.push(AddonsTriggerVersionProPage);
      }
    }
  }

  getRowClass(row) {
    return {
      'not-active': row._active === false
    };
  }

  updateElementFirestore(collection, element_uid, values) {
    this.cartaMenuServices.afs.collection(collection).doc(element_uid).update(values);
  }

  openShare(url, type, element_uid) {
    this.comboServices.url_share_xxss = url;
    this.menuServices.url_share_xxss = url;
    this.cartaServices.url_share_xxss = url;
    //open share
    let profileModal = this.modalCtrl.create(ShareXxssPage, {
      url: url,
      type: type,
      style: "list",
      xxss: {
        preview: true,
        whatsapp: true,
        twitter: true,
        facebook: true,
        instagram: true,
        email: true,
        copy: true,
        print: true,
        qr: true,
        xxss: false
      },
      element_uid: element_uid,
      modal: true,
    });
    profileModal.present();
  }

  onSort(event) {
    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => this.globals.returnLangCartaMenuCombo(a).localeCompare(this.globals.returnLangCartaMenuCombo(b)));
        } else {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => this.globals.returnLangCartaMenuCombo(b).localeCompare(this.globals.returnLangCartaMenuCombo(a)));
        }
        break;
      case 'ref':
        if (event.newValue == 'asc') {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (a.reference || '').localeCompare((b.reference || '')));
        } else {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (b.reference || '').localeCompare((a.reference || '')));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => a.type.localeCompare(b.type));
        } else {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
      case 'price':
        if (event.newValue == 'asc') {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (a.price || 0) - (b.price || 0));
        } else {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (b.price || 0) - (a.price || 0));
        }
        break;
      case 'digital_app':
        if (event.newValue == 'asc') {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (a.digital_app || false) - (b.digital_app || false));
        } else {
          this.cartaMenuServices.cartas_menu_combo_array_tmp.sort((a, b) => (b.digital_app || false) - (a.digital_app || false));
        }
        break;
    }
    this.cartaMenuServices.cartas_menu_combo_array_tmp = [...this.cartaMenuServices.cartas_menu_combo_array_tmp];
  }

  async getViewsShares() {
    const params = new HttpParams()
      .set('rest_uid', this.globals.restaurant_uid)
      .set('first_date', this.actual_day_less_6)
      .set('last_date', this.actual_day);

    this.http.post(this.globals.analytics_path + 'analytics/total_views_share_general', params, {})
      .subscribe(async response => {
        this.total_views = response['total_views'];
        this.total_shares = response['total_share'];
      });
  }

  pay() {
    var final_path = this.globals.api_path + "suscription/" + this.globals.user_email + "/stripe/carta-menu/month";
    //
    if (this.globals.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/cartas-menus/cartas-menus-list/cartas-menus-list.ts